﻿let spinnerTimer = null;
let counter = 0;

export const invokeTimerPopup = (spinnerMessages, backgroundColor, SpinnerMessageIntervals) => {
    if (spinnerTimer !== null) {
        console.log("Spinner already running...");
    } else {
        let messages = spinnerMessages.split("|");
        let timerPopupElement = document.createElement("div");
        let spinnerSection = document.createElement("div");
        let spinnerIcon = document.createElement("div");
        let spinnerMessage = document.createElement("div");
        timerPopupElement.setAttribute("id", "timerPopup");
        spinnerSection.setAttribute("class", "spinner-section");
        spinnerIcon.setAttribute("class", "wizard-spinner wizard-spinner__small");
        spinnerMessage.setAttribute("class", "spinner-message");
        spinnerIcon.appendChild(createSpinnerIcon());
        spinnerSection.appendChild(spinnerIcon);
        spinnerSection.appendChild(spinnerMessage);
        timerPopupElement.appendChild(spinnerSection);
        document.body.appendChild(timerPopupElement);

        if (backgroundColor === "Primary") {
            document.querySelector(".spinner-section").classList.add("spinner-section__primary");
        } else {
            document.querySelector(".spinner-section").classList.remove("spinner-section__primary");
        }

        showMessage(messages[counter]);
        counter++;

        spinnerTimer = setInterval(() => {
            showMessage(messages[counter]);
            counter++;
            if (counter === messages.length) {
                counter = 0;
            }
        }, SpinnerMessageIntervals * 1000);
    }
}

function createSpinnerIcon() {
    let spinnerLine;
    let spinnerIds = document.createElement("div");
    spinnerIds.setAttribute("class", "wizard-lds-spinner");
    for (let i = 0; i < 12; i++) {
        spinnerLine = document.createElement("div");
        spinnerIds.appendChild(spinnerLine);
    }

    return spinnerIds;
}

export const removeTimerPopup = () => {
    clearInterval(spinnerTimer);

    var elem = document.querySelector('#timerPopup');
    if (elem) {
        elem.parentNode.removeChild(elem);
    }
    counter = 0;
    spinnerTimer = null;
}
function showMessage(msg) {
    document.querySelector(".spinner-message").innerHTML = msg;
}
